import React, { useState } from 'react';
import { getRuta } from '../../../../helpers/Helpers';
import {
	BotonGenerar,
	FormularioSelector,
	SelectorGestor
} from '../../../../components/reportes/selector';

// La tabla se ordena con un clic en el encabezado. La ruta conserva su tercer segmento
// para no romper enlaces anteriores: 0 = por nombre.
const ORDEN_INICIAL = 0;

const SelectorAnalysisWallet = () => {
	const [selectedGestor, setSelectedGestor] = useState('t');

	let ruta = getRuta();

	const verReport = () => {
		var params = `${selectedGestor}/${ORDEN_INICIAL}`;
		window.open(`${ruta}/r-analyticswallet/${params}`);
	};

	return (
		<FormularioSelector>
			<SelectorGestor value={selectedGestor} onChange={setSelectedGestor} />

			<BotonGenerar onClick={verReport} />
		</FormularioSelector>
	);
};

export default SelectorAnalysisWallet;
